import * as $ from 'jquery';
import SDIConstants, { getAPIURL, ConvertToEst } from './SDIConstants';
import * as CookieService from './CookieService';
import { saveAs } from 'file-saver';

let callSecureGateway = async (module, method, data, callback) => {
    let serviceURL = await getAPIURL();
    //console.log("serviceURL", serviceURL);
    try {
        let payload = { moduleName: module, methodName: method, data: data, accessMode: 2, userID: CookieService.getLocalStorageValues("Session_UserID") };

        let response = await $.ajax({
            type: "POST",
            url: `${serviceURL}api/SDISecure/messageInterface`,
            data: payload,
            headers: {
                //[10/3/22],PS_AT_03, WAL - Login authorization token (load balancer fix) - To pass user ID for basic authentication, Dhevanesam R
                "UserName": CookieService.getLocalStorageValues("Session_UserID"),
                "Authorization": "Bearer " + CookieService.getCookieValue(SDIConstants.access_token),
                "SystemCode": "WALW",
                "FromHomePage": method == 5 ? "true": "false"
            }
        });
        let isTokenExpired = false;
        let result = {};
        let Filecheck;
        let res;
        if (response)
            // Check response have Filecheck data - Nandhini L
            if (response.includes("Filecheck")) {
                res = JSON.parse(response);
                Filecheck = res.Filecheck

                if (Filecheck && Filecheck[0] && Filecheck[0].isredirect == "True") {
                    let newlang = CookieService.getLocalStorageValues("newlanguage");
                    let lastversion = CookieService.getLocalStorageValues("lastVersion");
                    CookieService.setCookieValues(SDIConstants.access_token, "", -1);
                    localStorage.clear();
                    CookieService.updateLocalStorageValues("lastVersion", lastversion);
                    let lv = CookieService.getLocalStorageValues("lastVersion");
                    CookieService.updateLocalStorageValues("newlanguage", newlang);
                    CookieService.updateLocalStorageValues("isSSOClick", false);
                    CookieService.updateLocalStorageValues("isLogout", true);
                    window.location.href = '/';
                    return
                }
            }
            isTokenExpired = response.indexOf("Token Expired") >= 0 ? true : false;
        if (isTokenExpired == false) {
            result = {
                "success": true,
                "response": response
            };
        } else {
            result = {
                "success": false,
                "response": SDIConstants.tokenExpired
            };
        }
        callback(result);
    }
    catch (ex) {
        let result = {
            "success": false,
            "response": ex
        };
        callback(result);
    }

}
//[10/3/22], PS_AT_01, WAL - Login authorization token (load balancer fix) - To call mobile controller for access token, Dhevanesam R
let callMobileGateway = async (module, method, data, callback) => {
    let serviceURL = await getAPIURL();
    //console.log("serviceURL", serviceURL);
    try {
        let payload = { moduleName: module, methodName: method, data: data, accessMode: 2, userID: CookieService.getLocalStorageValues("Session_UserID") };

        let response = await $.ajax({
            type: "POST",
            url: `${serviceURL}api/SDIMobile/messageInterface`,
            data: payload,
            headers: {
                "Authorization": "Bearer " + CookieService.getCookieValue(SDIConstants.access_token),
                 "SystemCode": "WALW"
            }
        });
        let isTokenExpired = false;
        let result = {};
        let Filecheck;
        let res;
        if (response)
            // Check response have Filecheck data - Nandhini L
            if (response.includes("Filecheck")) {
                res = JSON.parse(response);
                Filecheck = res.Filecheck

                if (Filecheck && Filecheck[0] && Filecheck[0].isredirect == "True") {
                    let newlang = CookieService.getLocalStorageValues("newlanguage");
                    let lastversion = CookieService.getLocalStorageValues("lastVersion");
                    CookieService.setCookieValues(SDIConstants.access_token, "", -1);
                    localStorage.clear();
                    CookieService.updateLocalStorageValues("lastVersion", lastversion);
                    let lv = CookieService.getLocalStorageValues("lastVersion");
                    CookieService.updateLocalStorageValues("newlanguage", newlang);
                    CookieService.updateLocalStorageValues("isSSOClick", false);
                    CookieService.updateLocalStorageValues("isLogout", true);
                    window.location.href = '/';
                    return
                }
            }
        isTokenExpired = response.indexOf("Token Expired") >= 0 ? true : false;
        if (isTokenExpired == false) {
            CookieService.updateLocalStorageValues("isLoginSuccess", true)
            result = {
                "success": true,
                "response": response
            };
        } else {
            CookieService.updateLocalStorageValues("isLoginSuccess", false)
            result = {
                "success": false,
                "response": SDIConstants.tokenExpired
            };
        }
        callback(result);
    }
    catch (ex) {
        let result = {
            "success": false,
            "response": ex
        };
        callback(result);
    }

}
let callRecurringGateway = async (module, method, data, callback) => {
    let serviceURL = await getAPIURL();
    //console.log("serviceURL", serviceURL);
    try {
        let payload = { moduleName: module, methodName: method, data: data, accessMode: 2, userID: CookieService.getLocalStorageValues("Session_UserID") };
        let response = await $.ajax({
            type: "POST",
            url: `${serviceURL}api/SDITimeOut/messageInterface`,
            data: payload,
            headers: {
                //[10/3/22], PS_AT_03, WAL - Login authorization token (load balancer fix) - To pass user ID for basic authentication, Dhevanesam R
                "UserName": CookieService.getLocalStorageValues("Session_UserID"),
                "Authorization": "Bearer " + CookieService.getCookieValue(SDIConstants.access_token)
                ,"SystemCode": "WALW"
            }
        });
        let isTokenExpired = false;
        let result = {};
        let Filecheck;
        let res;
        if (response)
            // Check response have Filecheck data - Nandhini L
            if (response.includes("Filecheck")) {
                res = JSON.parse(response);
                Filecheck = res.Filecheck

                if (Filecheck && Filecheck[0] && Filecheck[0].isredirect == "True") {
                    let newlang = CookieService.getLocalStorageValues("newlanguage");
                    let lastversion = CookieService.getLocalStorageValues("lastVersion");
                    CookieService.setCookieValues(SDIConstants.access_token, "", -1);
                    localStorage.clear();
                    CookieService.updateLocalStorageValues("lastVersion", lastversion);
                    let lv = CookieService.getLocalStorageValues("lastVersion");
                    CookieService.updateLocalStorageValues("newlanguage", newlang);
                    CookieService.updateLocalStorageValues("isSSOClick", false);
                    CookieService.updateLocalStorageValues("isLogout", true);
                    window.location.href = '/';
                    return
                }
            }
            isTokenExpired = response.indexOf("Token Expired") >= 0 ? true : false;
        if (isTokenExpired == false) {
            result = {
                "success": true,
                "response": response
            };
        } else {
            result = {
                "success": false,
                "response": SDIConstants.tokenExpired
            };
        }
        callback(result);
    }
    catch (ex) {
        let result = {
            "success": false,
            "response": ex
        };
        callback(result);
    }

}
let SamFed = async (callback) => {
    
    try {
        //let payload = { 'grant_type': 'client_credentials', 'client_id': 'l73734da49be51475a8879655f0df53ecf', 'client_secret': '6c3f275ea035419da546b004ba796db9' };
        let responsefedex = {
            "labelResponseOptions": "URL_ONLY",
            "freightRequestedShipment": {
                "shipper": {
                    "address": {
                        "streetLines": [
                            "1202 Chalet Ln",
                            "Do Not Delete - Test Account"
                        ],
                        "city": "Harrison",
                        "stateOrProvinceCode": "AR",
                        "postalCode": 72601,
                        "countryCode": "US"
                    },
                    "contact": {
                        "personName": "Shipper Name",
                        "phoneNumber": 1231231231,
                        "companyName": "Shipper Company Name"
                    }
                },
                "recipient": {
                    "address": {
                        "streetLines": [
                            "1234 Main St",
                            "Suite 200"
                        ],
                        "stateOrProvinceCode": "OH",
                        "city": "Akron",
                        "postalCode": 44333,
                        "countryCode": "US",
                        "residential": false
                    },
                    "contact": {
                        "personName": "Recipient name",
                        "companyName": "Recipient Company Name",
                        "phoneNumber": 1234567890
                    },
                    "deliveryInstructions": "Deliver to Front Gate"
                },
                "pickupType": "CONTACT_FEDEX_TO_SCHEDULE",
                "serviceType": "FEDEX_FREIGHT_ECONOMY",
                "packagingType": "YOUR_PACKAGING",
                "shippingChargesPayment": {
                    "paymentType": "SENDER",
                    "payor": {
                        "responsibleParty": {
                            "accountNumber": {
                                "value": "510051408"
                            }
                        }
                    }
                },
                "freightShipmentDetail": {
                    "role": "SHIPPER",
                    "totalHandlingUnits": 1,
                    "lineItem": [
                        {
                            "pieces": 1,
                            "handlingUnits": 1,
                            "freightClass": "CLASS_050",
                            "subPackagingType": "PALLET",
                            "description": "School Text Books",
                            "weight": {
                                "units": "LB",
                                "value": 200
                            },
                            "id": 7
                        }
                    ],
                    "alternateBillingParty": {
                        "accountNumber": {
                            "value": "510051408"
                        },
                        "contact": {
                            "companyName": "Third-Party Company",
                            "phoneNumber": 8705551234
                        },
                        "address": {
                            "streetLines": [
                                "2000 Freight LTL Testing",
                                "Do Not Delete - Test Account"
                            ],
                            "city": "Harrison",
                            "stateOrProvinceCode": "AR",
                            "postalCode": 72601,
                            "countryCode": "US"
                        }
                    }
                },
                "labelSpecification": {
                    "imageType": "PDF",
                    "labelFormatType": "COMMON2D",
                    "labelStockType": "PAPER_LETTER"
                },
                "shippingDocumentSpecification": {
                    "shippingDocumentTypes": [
                        "FEDEX_FREIGHT_STRAIGHT_BILL_OF_LADING"
                    ],
                    "freightBillOfLadingDetail": {
                        "format": {
                            "stockType": "PAPER_LETTER",
                            "docType": "PDF"
                        }
                    }
                },
                "requestedPackageLineItems": [
                    {
                        "weight": {
                            "units": "LB",
                            "value": 200
                        },
                        "dimensions": {
                            "length": 150,
                            "width": 90,
                            "height": 100,
                            "units": "IN"
                        },
                        "associatedFreightLineItems": [
                            {
                                "id": 7
                            }
                        ],
                        "subPackagingType": "PALLET"
                    }
                ]
            },
            "accountNumber": {
                "value": "510087020"
            }
        }
        let response = await $.ajax({
            type: 'POST',
            url: 'https://apis-sandbox.fedex.com/ship/v1/shipments',
            data: JSON.stringify(responsefedex),
            headers: {
                'content-type': 'application/json',
                'Authorization': 'Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJzY29wZSI6WyJDWFMiLCJTRUNVUkUiXSwiUGF5bG9hZCI6ImFLcEpEZEJ1MXN4WmY3bEpFOUxxd2g3OEFCZ3FCSzcxa2hvdkRnWHpWWUo4aXAwcGJsS1E5QVk3MlpuWFVVbGEwRXdJZDVOZnFRdDFzS2xiS0FKUFIweUVsejVWRmxNbHRrZmE0RXRxZmZOSnpXSVAwQlF4UlFsN0FCMjJOdUNwZHVnNTNuV0d0RzVFQTltR3lET2NCcityeSswMkpUd0c4R3RDS1BYa05uQTBtZCtrTWFTWXNtQnV1RHhQMHNQZTBJM091cEJsUVZGUVl2MXhWd3JaNkRVeHY5Y0hzMEIzdnV3cUlRbXFiSlBSVVAyaWljS1JyY3RYTHczOWZqdFZXTHVud1FHZ0xtYk5YMWVyb21oSVEvaHJRQzZMWTJwTHd0bGFaRkdRVzNFPSIsImV4cCI6MTY0NzQ0MTExMSwianRpIjoiNWJlNTY1M2QtNTI5YS00OGE3LWI1YmQtYzVlMGY2YmZjODc4IiwiY2xpZW50X2lkIjoibDczNzM0ZGE0OWJlNTE0NzVhODg3OTY1NWYwZGY1M2VjZiJ9.ghO-fv6dmnCdfq6evp2oeS42jvU_mIoVSEoUMHzLQwozRqd6F_4d2kltDTReB7KitI39wB_M5E0JjYT54hotpI780xSK3cnCXI0yexeDODCmsEpXIRBLIDYbhor57oLCAz905OxBLyKD-x1DoxeSn2O09qM0YcAifhNFRPLZ2SBcBVlxiexNphQjd9UtLVwbe5hY5lT4aWUUnaMp72OIRwnv52oBpD1nVMcO7AzVcrk85rmOqyLiebEq-NmwzaCYrXYW2M8GB0wOVRjVQBUWjuIpbb-01iug-MIW42NRSXuqQZv_phkMxT0C7nUkr2Pe0z59xxItllQPVp0tJVuHL6qFBrqtFpusL8OcpXPSfguWxSJvHtLJW6dTXXy7tlq2ml2ipVwmQ6RrcCT5mwba9prtggpnewEOMDSTP4swGJG17NeW58xCztvYEsr368ru8Kk1A7vekkjCNrBB2u7FGYRrl4cA7cFuWB_2v00KrX7_YHxosO8ivqmd_CIoirSoXfKLeR4zyEGAZqcZY6CkdmDVRyULWK_sC0eNFKappC5942hXc604xErb-JVrZje0Tq_7tE95UOJ-fqQLzrWKONFuXZCCr4wBEs9jcBFfmdeLyq-6PYaQW_FOn-FqcT7GrhCjZROz6RE-3e_GRNJwKHlDkZ-eaJ0FrmkDSfr8QaU'
            }
        });
        let result = {
            "success": true,
            "response": response
        };
        callback(result);
    }
    catch (ex) {
        let result = {
            "success": false,
            "response": "",
            "error": ex
        };
        callback(result);
    }
}
let FedexAuth = async (callback) => {
    try {
        var data = "grant_type=client_credentials&client_id=l73734da49be51475a8879655f0df53ecf&client_secret=6c3f275ea035419da546b004ba796db9";
        let response = await $.ajax({
            type: "POST",
            url: "https://apis-sandbox.fedex.com/oauth/token",
            data: data,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        });
        let result = {
            "success": true,
            "response": response
        };
        callback(result);
    }
    catch (ex) {
        let result = {
            "success": false,
            "response": "",
            "error": ex
        };
        callback(result);
    }
}


let FedexShipping = async (data, callback) => {
    ;

    try {
        let payload = { data: data.shipping };
        let response = await $.ajax({
            type: "POST",
            url: "https://apis-sandbox.fedex.com/ship/v1/shipments",
            header: data.token,
            data: payload,
        });
        let result = {
            "success": true,
            "response": response
        };
        callback(result);
    }
    catch (ex) {
        let result = {
            "success": false,
            "response": ex
        };
        callback(result);
    }

}



let callGateway = async (module, method, data, callback) => {
    let serviceURL = await getAPIURL();
    //console.log("serviceURL", serviceURL);
    try {
        let payload = { moduleName: module, methodName: method, data: data, accessMode: 2 };
        let response = await $.ajax({
            type: "POST",
            url: `${serviceURL}api/SDIAPI/messageInterface`,
            data: payload,
            headers: {
                "SystemCode": "WALW"
            }
        });
        let isTokenExpired = false;
        let result = {};
        let Filecheck;
        let res;
        if (response)
            // Check response have Filecheck data - Nandhini L
            if (response.includes("Filecheck")) {
                res = JSON.parse(response);
                Filecheck = res.Filecheck

                if (method != 362 && method != 316 && Filecheck && Filecheck[0].isredirect == "True") {
                    let newlang = CookieService.getLocalStorageValues("newlanguage");
                    let lastversion = CookieService.getLocalStorageValues("lastVersion");
                    CookieService.setCookieValues(SDIConstants.access_token, "", -1);
                    localStorage.clear();
                    CookieService.updateLocalStorageValues("lastVersion", lastversion);
                    let lv = CookieService.getLocalStorageValues("lastVersion");
                    CookieService.updateLocalStorageValues("newlanguage", newlang);
                    CookieService.updateLocalStorageValues("isSSOClick", false);
                    CookieService.updateLocalStorageValues("isLogout", true);
                    CookieService.updateLocalStorageValues("chgAndForPWClick", false);

                    if (method == 89 || method == 90) {
                        let check = Filecheck[0];
                        if (check && check.result) {
                            const localStorageLanguageCode = CookieService.getLocalStorageValues("newlanguage");
                            let result = JSON.parse(check.result);

                            let isredirect = check.isredirect;

                            const langResult = result[0].messages;
                            const displayDateTimeStart = ConvertToEst(result[0].displayDateTimeStart);
                            const outageDateTimeStart = ConvertToEst(result[0].outageDateTimeStart);
                            const outageDateTimeEnd = ConvertToEst(result[0].outageDateTimeEnd);

                            const filteredLangResult = langResult.find(msg => msg.languageCode === localStorageLanguageCode.value);
                            let externalMessage = filteredLangResult && filteredLangResult.externalMessage;
                            externalMessage = externalMessage
                                .replace('outageDateTimeStart', outageDateTimeStart)
                                .replace('outageDateTimeEnd', outageDateTimeEnd);

                            CookieService.updateLocalStorageValues("displayText", externalMessage);
                            CookieService.updateLocalStorageValues("isredirect", isredirect);
                            CookieService.updateLocalStorageValues("resultMessage", Filecheck);

                            if (isredirect == "True") {
                                window.location.href = '/underMaintanance';
                                return
                            }

                        } else {
                            window.location.href = '/';
                            return
                        }
                    }
                }
            }

        isTokenExpired = response.indexOf("Token Expired") >= 0 ? true : false;
        if (isTokenExpired == false) {
            result = {
                "success": true,
                "response": response
            };
        } else {
            result = {
                "success": false,
                "response": SDIConstants.tokenExpired
            };
        }
        callback(result);

       
    }
    catch (ex) {
        let result = {
            "success": false,
            "response": ex
        };
        callback(result);
    }

}
let uploadFile = async (module, method, data, files, callback) => {
    let serviceURL = await getAPIURL();
    //console.log("serviceURL", serviceURL);
    try {
        // Create FormData object
        let fileData = new FormData();
        // Looping over all files and add it to FormData object
        for (let i = 0; i < files.length; i++) {
            fileData.append(files[i].name, files[i]);
        }
        let payload = { moduleName: module, methodName: method, data: data, accessMode: 2 };
        fileData.append('supportData', JSON.stringify(payload));
        let response = await $.ajax({
            type: "POST",
            url: `${serviceURL}api/SDIFile/upload`,
            data: fileData,
            processData: false,
            contentType: false,
            headers: {
                "SystemCode": "WALW"
            }

        });
        let Filecheck;
        let res;
        if (response) 
            // Check response have Filecheck data - Nandhini L
            if (response.includes("Filecheck")) {
                res = JSON.parse(response);
                Filecheck = res.Filecheck

                if (Filecheck && Filecheck[0] && Filecheck[0].isredirect == "True") {
                    let newlang = CookieService.getLocalStorageValues("newlanguage");
                    let lastversion = CookieService.getLocalStorageValues("lastVersion");
                    CookieService.setCookieValues(SDIConstants.access_token, "", -1);
                    localStorage.clear();
                    CookieService.updateLocalStorageValues("lastVersion", lastversion);
                    let lv = CookieService.getLocalStorageValues("lastVersion");
                    CookieService.updateLocalStorageValues("newlanguage", newlang);
                    CookieService.updateLocalStorageValues("isSSOClick", false);
                    CookieService.updateLocalStorageValues("isLogout", true);
                    window.location.href = '/';
                    return
                }
            }
            let result = {
                "success": true,
                "response": response
            };
            callback(result);
    }
    catch (ex) {
        let result = {
            "success": false,
            "response": ex
        };
        callback(result);
    }

}
let downloadFile = async (module, method, data, fileName, callback) => {
    let serviceURL = await getAPIURL();
    let createAjaxSettings = (xhrFields) => ({
        type: "POST",
        url: `${serviceURL}api/SDIFile/download`,
        data: { moduleName: module, methodName: method, data: data, accessMode: 2 },
        headers: {
            "SystemCode": "WALW"
        },
        xhrFields: xhrFields ? { responseType: 'arraybuffer' } : {},
        success: (response, status, xhr) => {
            const contentType = xhr.getResponseHeader("Content-Type");
            const statusCode = xhr.status;

            if (statusCode === 203 && contentType && contentType.indexOf("text/plain") !== -1) {
                // Handle the outage response
                let Filecheck;
                let res;
                if (response) {
                    // Check response have Filecheck data - Nandhini L
                    if (response.includes("Filecheck")) {
                        res = JSON.parse(response);
                        Filecheck = res.Filecheck
                    }
                    if (Filecheck && Filecheck[0] && Filecheck[0].isredirect == "True") {
                        let newlang = CookieService.getLocalStorageValues("newlanguage");
                        let lastversion = CookieService.getLocalStorageValues("lastVersion");
                        CookieService.setCookieValues(SDIConstants.access_token, "", -1);
                        localStorage.clear();
                        CookieService.updateLocalStorageValues("lastVersion", lastversion);
                        CookieService.updateLocalStorageValues("newlanguage", newlang);
                        CookieService.updateLocalStorageValues("isSSOClick", false);
                        CookieService.updateLocalStorageValues("isLogout", true);
                        window.location.href = '/';
                        return
                    }
                }
            } else if (contentType && contentType.indexOf("application/octet-stream") !== -1 && xhrFields) {
                // Handle the binary file response
                let file = new Blob([response], { type: "application/octet-stream" });
                saveAs(file, fileName);

                let result = {
                    "success": true,
                    "response": ""
                };
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                callback(result);
            } else {
                let result = {
                    "success": false,
                    "response": ""
                };
                callback(result);
            }
        },
        error: (xhr, status, error) => {
            let result = {
                "success": false,
                "response":""
            };
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            callback(result);
        }
    });

    try {
        let initialSettings = createAjaxSettings(false);

        // Initial AJAX call without xhrFields
        let initialRequest = $.ajax(initialSettings);

        // Handle after the initial request only if necessary
        initialRequest.done((response, status, xhr) => {
            const contentType = xhr.getResponseHeader("Content-Type");

            if (contentType && contentType.indexOf("application/octet-stream") !== -1) {
                // Redo request with `xhrFields`
                let binarySettings = createAjaxSettings(true);
                $.ajax(binarySettings);
            }
        });

    } catch (ex) {
        let result = {
            "success": false,
            "response": ex
        };
        callback(result);
    }
}
let receiveFileBase64 = async (module, method, data, callback) => {
    let serviceURL = await getAPIURL();
    let createAjaxSettings = (xhrFields) => ({
        type: "POST",
        url: `${serviceURL}api/SDIFile/download`,
        data: { moduleName: module, methodName: method, data: data, accessMode: 2 },
        headers: {
            "SystemCode": "WALW"
        },
        xhrFields: xhrFields ? { responseType: 'arraybuffer' } : {},
        success: (response, status, xhr) => {
            const contentType = xhr.getResponseHeader("Content-Type");
            const statusCode = xhr.status;

            if (statusCode === 203 && contentType && contentType.indexOf("text/plain") !== -1) {
                // Handle the outage response
                let Filecheck;
                let res;
                if (response) {
                    // Check response have Filecheck data - Nandhini L
                    if (response.includes("Filecheck")) {
                        res = JSON.parse(response);
                        Filecheck = res.Filecheck
                    }

                    if (Filecheck && Filecheck[0] && Filecheck[0].isredirect == "True") {
                        let newlang = CookieService.getLocalStorageValues("newlanguage");
                        let lastversion = CookieService.getLocalStorageValues("lastVersion");
                        CookieService.setCookieValues(SDIConstants.access_token, "", -1);
                        localStorage.clear();
                        CookieService.updateLocalStorageValues("lastVersion", lastversion);
                        let lv = CookieService.getLocalStorageValues("lastVersion");
                        CookieService.updateLocalStorageValues("newlanguage", newlang);
                        CookieService.updateLocalStorageValues("isSSOClick", false);
                        CookieService.updateLocalStorageValues("isLogout", true);
                        window.location.href = '/';
                        return
                    }
                }
            } else if (contentType && contentType.indexOf("application/octet-stream") !== -1 && xhrFields) {
                // Handle the binary file response
                let file = new Blob([response], { type: "application/pdf" });
                var reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onloadend = function () {
                     var base64data = reader.result;
                     let result = {
                            "success": true,
                            "response": base64data
                     };
                     callback(result);
                 }
            }
            else {
                let result = {
                    "success": false,
                    "response": ""
                };
                callback(result);
            }
        },
        error: (xhr, status, error) => {
            let result = {
                "success": false,
                "response": ""
            };
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            callback(result);
        }
    });

    try {
        let initialSettings = createAjaxSettings(false);

        // Initial AJAX call without xhrFields
        let initialRequest = $.ajax(initialSettings);

        // Handle after the initial request only if necessary
        initialRequest.done((response, status, xhr) => {
            const contentType = xhr.getResponseHeader("Content-Type");

            if (contentType && contentType.indexOf("application/octet-stream") !== -1) {
                // Redo request with `xhrFields`
                let binarySettings = createAjaxSettings(true);
                $.ajax(binarySettings);
            }
        });

    } catch (ex) {
        let result = {
            "success": false,
            "response": ex
        };
        callback(result);
    }
}

let login = async (loginData, callback) => {
    let serviceURL = await getAPIURL();
   // console.log("serviceURL", serviceURL);
    try {
        
        var data = "grant_type=password&username=" + loginData.userName + "&password=" + loginData.password + "&accessMode=2&failureAttemptCount=" + loginData.failureAttemptCount + "&failureAttemptUname=" + loginData.failureAttemptUname + "&PARAM_DESTINATION_URL=" + loginData.PARAM_DESTINATION_URL + "&authToken=" + loginData.authToken + "&isSrcWeb=" + loginData.isWeb + "&SystemCode=" + loginData.SystemCode;
        console.log("data",data)
        let response = await $.ajax({
            type: "POST",
            url: `${serviceURL}token`,
            data: data,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        });
        
        //console.log("serviceURL-response", response);
        let result = {
            "success": true,
            "response": response
        };
        
        callback(result);
    }
    catch (ex) {
        console.log("serviceURL-ex", ex);
        
        let result = {
            "success": false,
            "response": "",
            "error": ex
        };
        callback(result);
    }

}
let callAsync = async (module, method, data, callback) => {
    let serviceURL = await getAPIURL();
    //console.log("serviceURL", serviceURL);
    try {
        let payload = { moduleName: module, methodName: method, data: data, accessMode: 2, userID: CookieService.getLocalStorageValues("Session_UserID") };

        let response = await $.ajax({
            type: "POST",
            url: `${serviceURL}api/SDISecureAsync/messageInterface`,
            data: payload,
            headers: {
                //[10/3/22], PS_AT_03, WAL - Login authorization token (load balancer fix) - To pass user ID for basic authentication, Dhevanesam R
                "UserName": CookieService.getLocalStorageValues("Session_UserID"),
                "Authorization": "Bearer " + CookieService.getCookieValue(SDIConstants.access_token),
              "SystemCode": "WALW"
            }
        });
        let isTokenExpired = false;
        let result = {};
        let Filecheck;
        let res;
        if (response) 
            // Check response have Filecheck data - Nandhini L
            if (response.includes("Filecheck")) {
                res = JSON.parse(response);
                Filecheck = res.Filecheck

                if (Filecheck && Filecheck[0] && Filecheck[0].isredirect == "True") {
                    let newlang = CookieService.getLocalStorageValues("newlanguage");
                    let lastversion = CookieService.getLocalStorageValues("lastVersion");
                    CookieService.setCookieValues(SDIConstants.access_token, "", -1);
                    localStorage.clear();
                    CookieService.updateLocalStorageValues("lastVersion", lastversion);
                    let lv = CookieService.getLocalStorageValues("lastVersion");
                    CookieService.updateLocalStorageValues("newlanguage", newlang);
                    CookieService.updateLocalStorageValues("isSSOClick", false);
                    CookieService.updateLocalStorageValues("isLogout", true);
                    window.location.href = '/';
                    return
                }
            }
        isTokenExpired = response.indexOf("Token Expired") >= 0 ? true : false;

        if (isTokenExpired == false) {
            result = {
                "success": true,
                "response": response
            };
        } else {
            result = {
                "success": false,
                "response": SDIConstants.tokenExpired
            };
        }
        callback(result);
    }
    catch (ex) {
        let result = {
            "success": false,
            "response": ex
        };
        callback(result);
    }
}

export { callSecureGateway, callRecurringGateway, callGateway, uploadFile, downloadFile, receiveFileBase64, login, callAsync, FedexAuth, SamFed, callMobileGateway }